import React, { useEffect, useContext, useState } from 'react'
import { v4 as uuidv4 } from 'uuid'
import Loadable from 'react-loadable'
import PropTypes from 'prop-types'
import Settings from './../config/pre'
import { AppContext } from './../providers'
import { getClient, convertHSLToHex } from './../utils/functions'
import {
  restoreFromLocalStorage,
  saveToLocalStorage,
} from './../utils/localStorage'
import {
  Button,
  Modal,
  Input,
  Header,
} from 'semantic-ui-react'
import { ReactComponent as Logo } from './../images/ico-bee.svg'

const currentTheme = (theme) => {
  switch (theme) {
    case 'dark':
      return <DarkTheme />
    case 'eightbit':
      return <EightbitTheme />
    case 'coral':
    default:
      return <CoralTheme />
  }
}

const EightbitTheme = Loadable({
  loader: () => import('./EightbitTheme'),
  loading() {
    return null
  }
})

const DarkTheme = Loadable({
  loader: () => import('./DarkTheme'),
  loading() {
    return null
  }
})

const CoralTheme = Loadable({
  loader: () => import('./CoralTheme'),
  loading() {
    return null
  }
})

const BeeConfiguration = (props) => {
  const { children } = props
  const { beeAPI } = useContext(AppContext)
  const { store, dispatch } = beeAPI
  const { theme } = store
  // TODO: commented because not used
  // const modulesGroups = [
  //   {
  //     label: 'Common',
  //     collapsable: false,
  //     collapsedOnLoad: false,
  //     modulesNames: [
  //       'Heading',
  //       'Paragraph',
  //       'List',
  //       'Image',
  //       'Button',
  //       'Divider',
  //       'Spacer',
  //       'Social',
  //       'DynamicContent',
  //       'Html',
  //       'Video',
  //       'Form',
  //       'Icons',
  //       'Menu',
  //       'Carousel',
  //       'Text'
  //     ]
  //   },
  //   {
  //     label: 'AddOns',
  //     collapsable: false,
  //     collapsedOnLoad: false,
  //     modulesNames: [
  //       'Mixed Content Demo',
  //       'Viewed',
  //       'Stickers',
  //       'Gifs'
  //     ]
  //   },
  //   {
  //     label: 'Rows',
  //     collapsable: false,
  //     collapsedOnLoad: false,
  //     modulesNames: [
  //       'Products',
  //     ]
  //   }
  // ]

  const getConfig = () => {
    return (
      {
        container: 'bee-plugin-container',
        language: 'en-US',
        ...Settings,
        loadingSpinnerDisableOnDialog: true,
        saveRows: true,
        disableBaseColors: true,
        disableColorHistory: true,
        templateLanguageAutoTranslation: true,
        // modulesGroups,

        // NOTE: Languages Disabled by Default - Moved to ToolBarActions.js
        // templateLanguage: { value: 'en-US', label: 'English' },
        // templateLanguages: [
        //   { value: 'it-IT', label: 'Italiano' },
        //   { value: 'fr-FR', label: 'Français' },
        // ],
      }
    )
  }

  useEffect(() => {
    const client = getClient()
    const config = getConfig()
    config.uid = client.clientUID
    const theme = restoreFromLocalStorage('theme') || 'coral'
    const username = restoreFromLocalStorage('bee-username')
    const uid = restoreFromLocalStorage('bee-uid') || config.uid
    const h = (360 * Math.random())
    const s = (25 + 70 * Math.random())
    const l = (85 + 10 * Math.random())
    dispatch({
      payload: {
        config: {
          ...config,
          ...restoreFromLocalStorage('config'),
          username,
          uid,
          userColor: `${convertHSLToHex(h, s, l)}`,
        },
        client,
        theme
      }
    })
  }, [dispatch])


  const isFirstVisit = !restoreFromLocalStorage('bee-username')
  const [username, setUsername] = useState('')
  const [isOpen, setOpen] = useState(isFirstVisit)

  const handleCloseModal = () => {
    const uid = uuidv4()
    saveToLocalStorage(uid, 'bee-uid')
    saveToLocalStorage(username, 'bee-username')
    setOpen(false)
    const config = getConfig()
    dispatch({
      payload: {
        config: {
          ...config,
          uid,
          username,
        },
      }
    })
  }

  return (
    <div id={`${theme || 'coral'}`}>
      { currentTheme(theme) }
      {children}
      <div id="welcomeprompt">
        <Modal
          dimmer="inverted"
          size="mini"
          open={isOpen}
          id="welcomeprompt"
        >
          <Modal.Header>
            <Header as='h3'>
              <Logo width="35" />&nbsp;
              Welcome to BEE Playground!
            </Header>
          </Modal.Header>
          <Modal.Content>
            <p>Let&#39;s personalize your demo.</p>
            <Input
              type="text"
              fluid
              label={{ icon: 'asterisk' }}
              labelPosition='right corner'
              onChange={e => setUsername(e.target.value)}
              value={username}
              placeholder="Enter your name"
            />
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={handleCloseModal}>
              Okay, let&#39;s go!
            </Button>
          </Modal.Actions>
        </Modal>
      </div>
    </div>
  )
}

BeeConfiguration.propType = {
  children: PropTypes.object
}

export default BeeConfiguration
